/** @format */
import variable from 'src/static/styles/var'
import dayjs from 'dayjs'

const trimCompactDecimals = (n: number): string => n.toFixed(2).replace(/\.?0+$/, '')

/**
 * 数值展示：0 为 "0"；低于 1000 为原始整数；
 * 超过 1000 为 k，超过 1000000 为 m。
 * 保留小数点后两位
 */
const THOUSAND = 1000
const MILLION = 1_000_000
export const tokenValueFormat = (value?: number | null): string => {
  if (value == null || !Number.isFinite(value)) {
    return '-'
  }
  if (value === 0) {
    return '0'
  }

  const sign = value < 0 ? '-' : ''
  const abs = Math.abs(value)

  if (abs >= MILLION) {
    return `${sign}${trimCompactDecimals(abs / MILLION)}m`
  }
  if (abs >= THOUSAND) {
    return `${sign}${trimCompactDecimals(abs / THOUSAND)}k`
  }
  return `${sign}${Math.trunc(abs)}`
}

const REPORT_TIME_HOUR_MS = 60 * 60 * 1000
const REPORT_TIME_DAY_MS = 24 * REPORT_TIME_HOUR_MS

/** 根据最近数据上报时间与当前时间的间隔，返回状态圆点颜色 */
export const getLastReportTimeDotColor = (
  reportTime?: string | null,
  now: dayjs.Dayjs = dayjs()
): string => {
  if (!reportTime) {
    return variable.disableColor
  }
  const time = dayjs(reportTime)
  if (!time.isValid()) {
    return variable.disableColor
  }
  const diffMs = now.diff(time)
  if (diffMs <= REPORT_TIME_HOUR_MS) {
    return variable.successColor
  }
  if (diffMs <= REPORT_TIME_DAY_MS) {
    return variable.warningColor
  }
  return variable.errorColor
}
